export const types = {
  Audio: 'Audio',
  Correlation: 'Correlation',
  FmReceiver: 'FmReceiver',
  FmReceiver2: 'FmReceiver2',
  Scheduler: 'Scheduler',
  TimeZone: 'TimeZone',
  SetLTEMode: 'SetLteMode',
  SetFmScan: 'SetFMScanList',
  FirmwareUpdate: 'FirmwareUpdate',
  UltraFirmwareUpdate: 'UltraFirmwareUpdate',
  UltraModemFirmwareUpdate: 'UltraModemFirmwareUpdate',
  ModemFirmwareUpdate: 'ModemFirmwareUpdate',
  SetServer: 'SetServer',
  Cmd_SetApn: 'Cmd_SetApn',
  Cmd_SetTimeSourcePref: 'Cmd_SetTimeSourcePref',
  Cmd_SetPDPtype: 'Cmd_SetPDPtype',
  SetPSMConfig: 'SetPSMConfig',
  Cmd_SetAGCConfig: 'Cmd_SetAGCConfig',
  Cmd_SetUltraAGCConfig: 'Cmd_SetUltraAGCConfig',
  Cmd_SetUltraLogConfig: 'SetUltraLogConfig',
  SetFlashBufferDepthConfig: 'SetFlashBufferDepthConfig',
  ClearFlashMemory: 'ClearFlashMemory',
  SET_FALLBACK_SERVER: 'Cmd_SetFallbackServer',
  SET_CAPABILITY_REGISTER: 'Cmd_SetCapabilityRegister',
  TPC_IP_PACKET_CONFIGURATION: 'TPC_IP_PACKET_CONFIGURATION',
  SetLTEConnectionTimeout: 'SetLTEConnectionTimeout',
  Adhoc_Correlation: 'SetAdhocSchedulerConfiguration',
  SetLeakValveMonitor: 'SetLeakValveMonitorList',
  SetFastBurstConfiguration: 'SetFastBurstConfiguration',
  SetSecondKeepAliveConfiguration: 'SetSecondKeepAliveConfiguration' // backend opcode 0x4E
};

export const commands = {
  RESET: 'Reset',
  GET_SCHEDULER_CONFIG: 'GetSchedulerConfiguration',
  GET_AUDIO_CONFIG: 'GetAudioConfiguration',
  GET_CORRELATION_CONFIG: 'GetCorrelationConfiguration',
  GET_TIME_ZOME: 'GetTimeZone',
  GET_LTE_MODE: 'GetLteMode',
  SET_FM_SCAN: 'SetFMScanList',
  START_FM_SCAN: 'StartFMScanList',
  GET_FM_CHANNEL: 'GetFmChannel',
  DEACTIVATE: 'Cmd_Deactivation',
  RESET: 'CmdReset',
  ACTIVATE_TOOLKIT: 'Cmd_ActivateToolKitNow',
  GET_SERVER: 'GetServer',
  GET_APN: 'Cmd_GetApn',
  GET_PDP: 'Cmd_GetPDPtype',
  GET_AGC: 'Cmd_GetAGCConfig',
  GET_ULTRA_LOG_CONFIG: 'GetUltraLogConfig',
  PURGE_ULTRA_LOG: 'PurgeUltraLogBlockData',
  GET_FLASH_CONF: 'Cmd_GetFlashBufferDepthConfig',
  GET_FALLBACK_SERVER: 'Cmd_GetFallbackServer',
  GET_CAPABILITY_REGISTER: 'Cmd_GetCapabilityRegister',
  GET_LTE_CONFIGURATION: 'Cmd_GetLTEConnectionTimeout',
  HIGH_PRIORITY_BIT_REQUEST: 'HighPriorityBitRequest',
  GET_FAST_BURST_CONFIG: 'GetFastBurstConfiguration', // backend opcode 0x91
  GET_SECOND_KEEPALIVE_CONFIG: 'GetSecondKeepAliveConfiguration', // backend opcode 0x4D
  // GET_SET_LEAK_VALVE_MONITOR_CONFIG: 'SetLeakValveMonitorList',
};
